export default "__VITE_ASSET__CMGNHMsj__"